import { toast } from "react-toastify";

/**
 * Common toast notification configurations
 */
const DEFAULT_TOAST_CONFIG = {
  position: "top-right" as const,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

/**
 * Shows a success notification
 * @param message - Success message to display
 * @param autoClose - Auto close time in milliseconds (default: 3000)
 */
export const showSuccessNotification = (
  message: string,
  autoClose: number = 3000
): void => {
  toast.success(message, {
    ...DEFAULT_TOAST_CONFIG,
    autoClose,
  });
};

/**
 * Shows an error notification
 * @param message - Error message to display
 * @param autoClose - Auto close time in milliseconds (default: 6000)
 */
export const showErrorNotification = (
  message: string,
  autoClose: number = 6000
): void => {
  toast.error(message, {
    ...DEFAULT_TOAST_CONFIG,
    autoClose,
  });
};

/**
 * Shows a warning notification
 * @param message - Warning message to display
 * @param autoClose - Auto close time in milliseconds (default: 5000)
 */
export const showWarningNotification = (
  message: string,
  autoClose: number = 5000
): void => {
  toast.warning(message, {
    ...DEFAULT_TOAST_CONFIG,
    autoClose,
  });
};

/**
 * Shows an info notification
 * @param message - Info message to display
 * @param autoClose - Auto close time in milliseconds (default: 4000)
 */
export const showInfoNotification = (
  message: string,
  autoClose: number = 4000
): void => {
  toast.info(message, {
    ...DEFAULT_TOAST_CONFIG,
    autoClose,
  });
};

/**
 * Session-specific notification messages
 */
export const SESSION_NOTIFICATIONS = {
  CREATE_ERROR: "Failed to create session. Please try again.",
  UPDATE_ERROR: "Failed to update session. Please try again.",
  SAVE_ERROR:
    "We couldn't save your session. Please check your information and try again.",
  LOAD_ERROR:
    "We couldn't load the session data. Please try again or go back to the sessions list.",
  NETWORK_ERROR:
    "Something went wrong while saving your session. Please check your connection and try again.",
  DATE_PARSE_WARNING:
    "The session date couldn't be loaded properly. We've set it to today's date - please verify and update if needed.",
} as const;
